import React from "react";
import ceoImage from "../../../assets/images/about/ceo.jpeg";

const CEO = () => {
  return (
    <div className="py-14 xl:py-20 px-2 md:px-7 lg:px-0 lg:w-5/6 xl:w-4/5 mx-auto mb-140 md:mb-20 lg:mb-110 xl:mb-20">
      <h2 className="mb-10 xl:mb-20 text-4xl xl:text-5xl">Our CEO</h2>
      
      <div className="flex flex-col lg:flex-row items-center lg:items-start gap-8 lg:gap-12">
        {/* CEO Image */}
        <div className="w-full lg:w-1/4">
          <div className="relative">
            <img
              src={ceoImage}
              alt="CEO"
              className="w-full h-auto rounded-lg shadow-lg transform transition-all duration-300 hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-lg"></div>
          </div>
        </div>
        
        {/* CEO Information */}
        <div className="w-full lg:w-3/4">
          <div className="space-y-6">
            <div>
              <h3 className="text-3xl xl:text-4xl font-bold text-gray-900 mb-2">
                Dr. Soran Jabbar Ali
              </h3>
              <p className="text-xl xl:text-2xl text-blue-600 font-semibold">
                Chief Executive Officer
              </p>
            </div>
            
            <div className="space-y-4">
              <p className="text-lg xl:text-xl text-gray-700 leading-relaxed">
              Dr. Soran Zangana is the visionary leader behind NABAZAt Al QALB’s rapid growth and strong presence in Iraq’s pharmaceutical market. With a deep understanding of healthcare needs and market dynamics, he has guided the company to become one of the top ten fast-growing local pharmaceutical distributors. Under his leadership, NABAZAt Al QALB continues to expand its portfolio, foster innovation, and maintain a culture of inclusivity, respect, and entrepreneurial spirit.
              </p>
      
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CEO;
